module.exports = __webpack_public_path__ + "static/media/addition-exam-icon.df6a351a.svg";